import React from 'react'

export default function SpecialTrainingGuidelines() {
    return <div>Special Training Guidelines</div>
}
